<template>
  {{format(props.value, options)}}
</template>
<script setup>
import { format } from '@/helpers/NumberFormatLib.js'


const props = defineProps({
  value: {
    type: [String, Number],
    required: true
  },
  usePrecision: {
    type: Boolean,
    required: false,
    default: true
  },
  precision: {
    type: Number,
    required: false,
    default: 2
  },
  thousandSep: {
    type: String,
    required: false,
    default: " "
  },
  decimalSep: {
    type: String,
    required: false,
    default: "."
  }
})

const options = {
  usePrecision: props.usePrecision,
  precision: props.precision,
  thousandSep: props.thousandSep,
  decimalSep: props.decimalSep
}

</script>
